export default __webpack_public_path__ + "static/media/166.edefaa74.jpg";